<template>
  <div id="Aside">
    <el-menu :default-active="defaulAtActive" class="el-menu-vertical" @open="handleOpen" @select="handleSelect" @close="handleClose" :collapse="isCollapse">
      <el-menu-item index="/">
        <i class="card-icon card-icon-home"></i>
        <span slot="title">
          {{ $t('menu.overview') }}
        </span>
      </el-menu-item>
      <el-submenu index="2">
        <template slot="title">
          <i class="card-icon card-icon-shopping"></i>
          <span slot="title">{{ $t('menu.myCommodity') }}</span>
        </template>
        <el-menu-item-group index="2-1">
          <el-menu-item index="/commodity/New">{{ $t('menu.addNewltem') }}</el-menu-item>
          <el-menu-item index="/commodity/Draft">{{ $t('menu.draft') }}</el-menu-item>
        </el-menu-item-group>
        <el-submenu index="2-2">
          <span slot="title" style="padding-left: 5px;">{{ $t('menu.active') }}</span>
          <el-menu-item index="/commodity/Active/Auction">{{ $t('menu.auction') }}</el-menu-item>
          <el-menu-item index="/commodity/Active/Buy">{{ $t('menu.buyItNow') }}</el-menu-item>
        </el-submenu>
        <el-menu-item-group index="2-3">
          <el-menu-item index="/commodity/Scheduled">{{ $t('menu.scheduled') }}</el-menu-item>
          <el-menu-item index="/commodity/Unsold">{{ $t('menu.unsold') }}</el-menu-item>
          <el-menu-item index="/commodity/Offer">{{ $t('menu.offer') }}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="/orders">
        <i class="card-icon card-icon-order"></i>
        <span slot="title">
          {{ $t('menu.myOrders') }}
        </span>
      </el-menu-item>
      <el-menu-item index="/data">
        <i class="card-icon card-icon-data"></i>
        <span slot="title">
          {{ $t('menu.myData') }}
        </span>
      </el-menu-item>
      <el-menu-item index="/store">
        <i class="card-icon card-icon-shop"></i>
        <span slot="title">
          {{ $t('menu.myStore') }}
        </span>
      </el-menu-item>
      <el-menu-item index="/wallet" v-if="haveWallet">
        <i class="card-icon card-icon-wallet "></i>
        <span slot="title">
          {{ $t('menu.wallet') }}
        </span>
      </el-menu-item>
      <!-- <el-menu-item index="/blacklist">
        <i class="card-icon card-icon-blacklist "></i>
        <span slot="title">
          {{ $t('menu.blacklist') }}
        </span>
      </el-menu-item> -->
      <el-menu-item index="/messages">
        <i class="card-icon card-icon-news"></i>
        <span slot="title">
          {{ $t('menu.notification') }}
        </span>
      </el-menu-item>
      <el-menu-item>
        <a slot="title" target="_blank" :href="wyimLink">
          <i class="card-icon card-icon-email"></i>
          <span>
            {{ $t('menu.messages') }}
          </span>
        </a>
      </el-menu-item>

    </el-menu>
    <div id="CollapseSwith" :class="[isCollapse ? 'menu-open' : 'menu-close']" @click="Collapse()">
      <!-- {{isCollapse?"展开":"收起"}} -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'AsideSwith',
  data() {
    return {
      wyimLink: `${this.$store.getters.CHAT('admin')}`,
      defaulAtActive: "/",
      isCollapse: false
    }
  },
  props: {
    path: Array,
  },
  computed: {
    haveWallet() {
      let AccountId = this.$store.state.UserInfo.AccountId;
      let MemberSource = this.$store.state.UserInfo.MemberSource;
      let Wallet = MemberSource != 'US' && (AccountId && AccountId.indexOf('payee_')>-1) ? true : false;
      return Wallet;
    }
  },
  mounted() {
    if(this.$route.path){
      let path = this.$route.path.slice(1).split("/");
      this.defaulAtActive="/"+path[0]
      if(path[0]=='commodity'){
        this.defaulAtActive = this.$route.path || "/"
      }
    }else{
      this.defaulAtActive="/";
    }
    // console.log(this.$route.path)
    // this.defaulAtActive = this.$route.path || "/";
  },
  methods: {
    Collapse() {
      this.isCollapse = !this.isCollapse;
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
      this.$router.push({ path: key }, () => { }, () => { });
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#Aside {
  padding: 10px 0;
  box-sizing: border-box;
  min-width: 60px;
  height: 100%;
  flex: none;
  position: relative;
}

#CollapseSwith {
  cursor: pointer;
  position: absolute;
  bottom: 5px;
  text-align: right;
  padding: 0 1%;
  width: 50px;
  height: 50px;
  left: 12px;
  /* width: 98%; */
}

.menu-open,
.menu-close {
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: auto;
}

.menu-open {
  background-image: url(../../static/images/btn-menu-open.svg);
}

.menu-close {
  background-image: url(../../static/images/btn-menu-close.svg);
}

.el-menu-vertical {
  /* max-height: calc(100%-5px); */
  /* overflow-y: auto; */
}

.el-menu {
  border-right: none;
}

i.card-icon {
  width: 24px;
  height: 24px;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: auto;
  display: inline-block;
}

.card-icon-home {
  background-image: url(../../static/images/icon_home.svg);
}

.is-active .card-icon-home {
  background-image: url(../../static/images/icon_home_blue.svg);
}

.card-icon-shopping {
  background-image: url(../../static/images/icon_shopping_cart.svg);
}

.is-active .card-icon-shopping {
  background-image: url(../../static/images/icon_shopping_cart_blue.svg);
}

.card-icon-order {
  background-image: url(../../static/images/icon_order.svg);
}

.is-active .card-icon-order {
  background-image: url(../../static/images/icon_order_blue.svg);
}

.card-icon-data {
  background-image: url(../../static/images/icon_data.svg);
}

.is-active .card-icon-data {
  background-image: url(../../static/images/icon_data_blue.svg);
}


.card-icon-shop {
  background-image: url(../../static/images/icon_shop.svg);
}

.is-active .card-icon-shop {
  background-image: url(../../static/images/icon_shop_blue.svg);
}

.card-icon-news {
  background-image: url(../../static/images/icon_news.svg);
}

.is-active .card-icon-news {
  background-image: url(../../static/images/icon_news_blue.svg);
}

.card-icon-wallet {
  background-image: url(../../static/images/icon-wallet.svg);
}

.is-active .card-icon-wallet {
  background-image: url(../../static/images/icon-wallet_blue.svg);
}

i.card-icon.card-icon-email {
  background-image: url(../../static/images/icons/email.svg);
  background-size: 75%;
}

.card-icon-coin {
  font-size: 20px;
}

/deep/ .el-menu-item {
  border-left: 4px solid #fff;
}

/deep/ .el-menu-item.is-active {
  background-color: #f7f7fb;
  border-left-color: #5f6dae;
}

/deep/ .el-menu-item.is-active,
/deep/ .is-active.is-opened>.el-submenu__title {
  font-weight: bold;
  color: #5f6dae;
}

/deep/ .el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow {
  color: #5f6dae;
}

/deep/ .el-submenu__icon-arrow {
  right: 10px;
}

/deep/ .el-menu-item-group__title {
  padding: 0;
  height: 1px;
}

/deep/ .el-submenu__title {
  padding-right: 30px;
}

/deep/ .el-submenu__title,
.el-menu-item,
.el-submenu .el-menu-item {
  height: 45px;
  line-height: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/aside-swith.vue